import { formatCurrency } from "~/lib/format";
import type { YearSummary } from "~/types/financials";
import { ChangeIndicator } from "./change-indicator";
import { Sparkline } from "./sparkline";

interface FinancialKpiCardsProps {
	years: YearSummary[];
}

export function FinancialKpiCards({ years }: FinancialKpiCardsProps) {
	const latest = years[years.length - 1];
	if (!latest) return null;

	const kpis = [
		{
			label: "Tržby",
			value: latest.revenue,
			change: latest.yoyChanges.revenue,
			sparkData: years.map((y) => y.revenue),
		},
		{
			label: "Čistý zisk",
			value: latest.netProfit,
			change: latest.yoyChanges.netProfit,
			sparkData: years.map((y) => y.netProfit),
		},
		{
			label: "Aktiva",
			value: latest.totalAssets,
			change: latest.yoyChanges.totalAssets,
			sparkData: years.map((y) => y.totalAssets),
		},
		{
			label: "Vlastní kapitál",
			value: latest.equity,
			change: latest.yoyChanges.equity,
			sparkData: years.map((y) => y.equity),
		},
	];

	return (
		<div className="grid gap-4 grid-cols-2 lg:grid-cols-4">
			{kpis.map((kpi) => (
				<div key={kpi.label} className="card-surface rounded-xl p-4">
					<p className="label-overline">{kpi.label}</p>
					<p className="text-2xl font-mono font-semibold tabular-nums mt-1.5">
						{formatCurrency(kpi.value)}
					</p>
					<div className="flex items-center justify-between mt-2">
						<ChangeIndicator value={kpi.change} />
						<Sparkline data={kpi.sparkData} />
					</div>
				</div>
			))}
		</div>
	);
}
